export const postRequest = async <T>(url: string, body?: BodyInit | null | undefined): Promise<T> => {
    const headers = {
        'X-CSRF-TOKEN': (document.getElementsByName("__RequestVerificationToken")[0] as HTMLInputElement).value
    };
    const response = await fetch(url, {
        method: 'POST',
        headers,
        body
    })
    if (!response.ok) {
        try {
            const data = await response.json();
            let err = new Error(data.errorMessage);
            throw err
        }
        catch {
            throw new Error("Het bestand kon niet geupload worden");
        }
    }
    const data = await response.json();
    return data;
}